import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { OrderStatusesRejected, type OrderStatusRejected } from '@exchange/libs/order/shared-model/src/lib/order-essentials';

import SimpleToast from '../SimpleToast.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderRejectedToast',
  props: {
  event: { type: Object as PropType<{ reason: string }>, required: true },
},
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { te } = useI18n({ useScope: 'global' });

const rowReason = computed(() => props.event.reason);

const reason = computed(() => {
  if (te(`modules.myOrders.toasts.rejected.reason.${rowReason.value}`)) {
    return `modules.myOrders.toasts.rejected.reason.${rowReason.value}`;
  }

  return 'modules.myOrders.toasts.rejected.reason.DEFAULT';
});

const title = computed(() => {
  if (OrderStatusesRejected.includes(rowReason.value as OrderStatusRejected)) {
    return 'modules.myOrders.toasts.rejected.titleRejected';
  }

  return 'modules.myOrders.toasts.rejected.title';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleToast, {
    variant: "failed",
    "icon-name": "danger",
    title: title.value,
    message: reason.value,
    onRemove: _cache[0] || (_cache[0] = ($event: any) => (emit('remove')))
  }, null, 8, ["title", "message"]))
}
}

})